import { render } from "./AddressSelectionModal.vue?vue&type=template&id=3618d91b&scoped=true"
import script from "./AddressSelectionModal.vue?vue&type=script&lang=js"
export * from "./AddressSelectionModal.vue?vue&type=script&lang=js"

import "./AddressSelectionModal.vue?vue&type=style&index=0&id=3618d91b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3618d91b"]])

export default __exports__